import Vue from 'vue'
import VueRouter from 'vue-router'
import Cajas from '../components/Cajas.vue'
import CajasToolbar from '../components/CajasToolbar.vue'
import VentasToolbar from '../components/VentasToolbar.vue'
import Ventas from '../components/Ventas.vue'
import CajaResumen from '../components/CajaResumen.vue'
import ReporteResumenCaja from '../components/ReporteResumenCaja.vue'
import CajaResumenToolbar from '../components/CajaResumenToolbar.vue'
import updateToolbar from '../components/UpdateToolbar.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/cajas',
    name: 'Cajas',
    components:
      {
        default:Cajas,
        toolbar:CajasToolbar
      }
  },
  {
    path: '/ventas/:idcaja/:estado',
    name: 'Ventas',
    components:
    {
      default:Ventas,
      toolbar:VentasToolbar
    }
  },
  {
    path: '/cajaresumen',
    name: 'Resumen de Caja',
    components:
    {
      default:CajaResumen,
      toolbar:CajaResumenToolbar
    },
    props: (route) => ({
        ...route.params
    })
  },
  {
    path: '/report/resumencaja',
    name: 'Reporte Resumen de caja',
    component: ReporteResumenCaja
  },
  {
    path: '/menu',
    name: 'Menu',
    component: ()=>import('../components/Menu.vue')
  },
  {
    path: '/ranking',
    name: 'Ranking de Platos',
    components: {
      default: ()=>import('../components/RankingPlatos.vue'),
      toolbar:updateToolbar
    }
  },
  {
    path: '/descuentos',
    name: 'Ventas Descuentos',
    components: {
      default: ()=>import('../components/VentasDescuentos.vue'),
      toolbar:updateToolbar
    }
  },
  {
    path: '/cmv',
    name: 'Costo Venta',
    components: {
      default:()=>import('../components/CMV.vue'),
      toolbar:updateToolbar
    },    
  },
  {
    path: '/movimientos',
    name: 'Ingresos Egresos',
    component: ()=>import('../components/Movimientos.vue')
  },
  {
    path: '/vtafecha',
    name: 'Ventas Por Fecha',
    component: ()=>import('../components/VentasFechas.vue')
  },
  {
    path: '/vtamp',
    name: 'Medios de Pago de Ventas',
    components: {
      default:()=>import('../components/VentasMedioDePago.vue'),
      toolbar:updateToolbar
    },    
  },  
  {
    path: '/borrados',
    name: 'Ventas con Eliminaciones',
    component: ()=>import('../components/VentasBorrados.vue')
  },  
  {
    path: '/vtadetalle',
    name: 'Ventas con Detalle',
    component: ()=>import('../components/VentasDetalle.vue')
  },    
  {
    path: '/vtahistorial/:idvta',
    name: 'Venta',
    components: {
      default:()=>import('../components/VentaHistorial.vue'),
      toolbar:updateToolbar
    },
  },    
  {
    path: '/comandas',
    name: 'Comandas',
    component: ()=>import('../components/Comandas.vue')
  },    
  {
    path: '/auditoria',
    name: 'Auditoria',
    component: ()=>import('../components/Auditoria.vue')
  },    
  {
    path: '/vtahora',
    name: 'Ventas Por Hora',
    components: {
      default:()=>import('../components/VentasPorHora.vue'),
      toolbar:updateToolbar
    },
  },  
  {
    path: '/comprafecha',
    name: 'Compras Por Fecha',
    component: ()=>import('../components/ComprasFechas.vue')
  }          
  ,
  {
    path: '/faststock',
    name: 'Stock Rapido',
    components: {
      default:()=>import('../components/stock/StockRapido.vue'),
      toolbar:updateToolbar
    },
  }  
  ,
  {
    path: '/',
    name: 'Estado Actual',
    components: {
      default:()=>import('../components/EstadoAct.vue'),
      toolbar:updateToolbar
    },
  }    
  ,
  {
    path: '/actprecios',
    name: 'Actualizador de Precios',
    components: {
      default:()=>import('../components/ActualizadorPrecios.vue'),
      toolbar:updateToolbar
    },
  }       
  ,
  {
    path: '/precios',
    name: 'Lista de Precios',
    components: {
      default:()=>import('../components/ModificarPrecios.vue'),
      toolbar:updateToolbar
    },
  } 
  ,
  {
    path: '/cpu',
    name: 'Uso de CPU',
    components: {
      default:()=>import('../components/CpuUsage.vue'),
      toolbar:updateToolbar
    },
  } 
]

const router = new VueRouter({
  routes
})

export default router
